import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ArticleWriterPage } from '@/features/articles/components';

function ArticleEditRoute(): ReactNode {
  const { slug } = Route.useParams();
  return (
    <AuthGuard>
      <ArticleWriterPage slug={slug} />
    </AuthGuard>
  );
}

// Auth-gated: only the author + manager+ can mutate. Detail load
// will 404 for non-author non-manager visits anyway, but the auth
// guard protects the surface from unauthenticated load. The
// server-side `viewerCanWrite` flag is the final authority — the
// writer disables every input when the article is archived.
export const Route = createFileRoute('/articles/$slug/edit')({
  component: ArticleEditRoute,
});
